import { Link } from "react-router-dom";
import { allArticles, allArticleImages } from "@/mocks/articles";

export default function BlogSection() {
  const featured = allArticles.filter((a) => a.isFeatured);
  const rest = allArticles.filter((a) => !a.isFeatured);
  const displayArticles = [...featured, ...rest];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <p className="text-xs md:text-sm text-foreground-500 font-label tracking-wider uppercase mb-3">
            / Knowledge Base
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Expert{" "}
            <span className="text-primary-600">SEO Guides</span>
            <br />
            &amp; Resources
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-4 max-w-xl mx-auto">
            Explore our complete library of acbuyspreadsheet guides, comparisons, and tutorials
          </p>
        </div>

        {/* Featured Article - Full Width */}
        {featured.length > 0 && (
          <Link
            to={`/blog/${featured[0].slug}`}
            className="group block mb-6 rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer hover:shadow-md transition-shadow duration-300"
          >
            <div className="flex flex-col lg:flex-row">
              <div className="lg:w-1/2 aspect-[3/4] lg:aspect-auto overflow-hidden">
                <img
                  src={allArticleImages[featured[0].slug] || ""}
                  alt={featured[0].title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="lg:w-1/2 flex flex-col justify-center p-6 md:p-8">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label font-semibold mb-3 w-fit">
                  Featured Article
                </span>
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug mb-3 group-hover:text-primary-600 transition-colors">
                  {featured[0].title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {featured[0].excerpt}
                </p>
                <span className="inline-flex items-center gap-2 mt-4 text-sm font-medium text-primary-600">
                  Read Full Guide
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </div>
          </Link>
        )}

        {/* Article Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rest.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              className="group flex flex-col rounded-xl overflow-hidden bg-background-100 border border-background-200/60 cursor-pointer hover:shadow-md transition-all duration-300"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={allArticleImages[article.slug] || ""}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 line-clamp-3">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-600">
                  Read More
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}